import React, { FC } from 'react';
import { SvgIcon as MuiSvgIcon } from '@material-ui/core';
import styled from 'styled-components';
import { SizeMap, SizeMapKeys, SpriteIcon } from 'src/config/api/models/FontAwesome';
import sprite from '../../../../assets/fontawesome/sprite.svg';

export type FontAwesomeSpriteIconProps = {
  icon: SpriteIcon;
  color?: string;
  iconSize?: SizeMapKeys;
  isDisabled?: boolean;
  iconStyle?: React.CSSProperties;
  iconLabel?: string;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const StyledSvgIcon = styled(({ iconSize, color, isDisabled, theme, ...other }) => (
  <MuiSvgIcon {...other} />
))`
  &.MuiSvgIcon-root {
    color: ${({ color, theme }) => (color ? color : theme.palette.primary.main)};
    height: ${({ iconSize }) => (iconSize ? SizeMap[iconSize as SizeMapKeys] : '1rem')};
    width: auto !important;
    aspect-ratio: 1;
    opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  }
`;

const FontAwesomeSpriteIcon: FC<FontAwesomeSpriteIconProps> = ({
  icon,
  iconStyle = {},
  iconLabel,
  ...other
}) => {
  return (
    <StyledSvgIcon style={iconStyle} {...other} aria-label={iconLabel}>
      <use href={`${sprite}#${icon}`} />
    </StyledSvgIcon>
  );
};

export default FontAwesomeSpriteIcon;
